import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import tcModel from '@wetransfer/transfer/modules/consent-manager/tc-model';
import I18n from '@wetransfer/transfer/modules/i18n';

import { Consent } from './consent';
import { ConnectedCustomPurposes } from './custom-purposes';
import { PurposeDescription } from './descriptions';
import { initPurposeListState } from './helper';

export function PurposeList({ consentLanguage, isWhiteText }) {
  const [preferences, setPreferences] = useState(
    initPurposeListState(consentLanguage)
  );

  useEffect(() => {
    setPreferences(initPurposeListState(consentLanguage));
  }, [consentLanguage]);

  const handlePurposeConsent = (id, checked) => {
    const newPref = { ...preferences };
    newPref[id].purposeConsent = checked;
    setPreferences(newPref);

    if (checked) {
      tcModel.purposeConsents.set(id);

      return;
    }

    tcModel.purposeConsents.unset(id);
  };

  const handleLegitimateInterest = (id, checked) => {
    const newPref = { ...preferences };
    newPref[id].purposeLegitimateInterest = checked;
    setPreferences(newPref);

    if (checked) {
      tcModel.purposeLegitimateInterests.set(id);

      return;
    }

    tcModel.purposeLegitimateInterests.unset(id);
  };

  const toggleDescription = (id) => {
    const newPref = { ...preferences };
    newPref[id].descriptionVisible = !newPref[id].descriptionVisible;
    setPreferences(newPref);
  };

  return (
    <>
      {Object.values(preferences).map(
        ({
          id,
          name,
          descriptionVisible,
          purposeLegitimateInterest,
          purposeConsentVisible,
          purposeConsent,
          descriptionLegal,
        }) => (
          <Consent
            key={id}
            onToggle={() => toggleDescription(id)}
            consentName={name}
            className={`consent ${isWhiteText ? 'consent__white' : ''}`}
            descriptionVisible={descriptionVisible}
            consentSwitchesProps={[
              {
                name: `legitimate-${id}`,
                label: I18n.t('transfer.consent-manager.switch-by-we-transfer'),
                onChange: (checked) => handleLegitimateInterest(id, checked),
                checked: purposeLegitimateInterest,
              },
              {
                name: `purpose-${id}`,
                disabled: !purposeConsentVisible,
                label: I18n.t('transfer.consent-manager.switch-by-partners'),
                onChange: (checked) => handlePurposeConsent(id, checked),
                checked: purposeConsent,
              },
            ]}
          >
            <PurposeDescription description={descriptionLegal} />
          </Consent>
        )
      )}
      <ConnectedCustomPurposes isWhiteText={isWhiteText} />
    </>
  );
}

PurposeList.propTypes = {
  consentLanguage: PropTypes.object,
  isWhiteText: PropTypes.bool,
};
